export default "__VITE_ASSET__a23b237a__"